import { Button, TextField, WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { CancelOutlined } from '@material-ui/icons';
import React from 'react';
import { ICustomerContractServiceSearchDTO } from '../../repository/jago/model/input/ICustomerContractServiceSearchDTO';
import _ from 'lodash';
import Select from 'react-select';
import ReduxLanguage from '../ReduxLanguage';
import translations from '../../translations/i18next';
import { CustomerContractServiceStatusOptions_ONEOFF, CustomerContractServiceStatusOptions_RECURRING } from '../../codec/customerContractServiceInDTODecoder';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
  },
  logo: {
    margin: 5,
    marginBottom: 15,
    alignSelf: 'center',
    height: 45,
  },
  text: {
    margin: 0,
    marginBottom: 0,
  },
  innerHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 10,
    marginLeft: 10,
  },
  title: {
    color: 'white',
  },
  circularProgress: {
    color: 'white',
  },
});


export interface ICustomerContractServicesSearchBarProps extends WithStyles<typeof styles> {
  onSearch: (searchValues: ICustomerContractServiceSearchDTO) => void;
  onResetSearch: () => void;
}

export interface ICustomerContractServiceStatusOption {
  label: string;
  value: string;
  original: string;
}

export interface ICustomerContractServicesSearchBarState {
  searchValues: Record<keyof ICustomerContractServiceSearchDTO, string>;
  statusSelected: ICustomerContractServiceStatusOption | undefined;
}

class CustomerContractServicesSearchBar extends React.Component<ICustomerContractServicesSearchBarProps, ICustomerContractServicesSearchBarState> {
  constructor(props: ICustomerContractServicesSearchBarProps) {
    super(props);
    this.state = {
      searchValues: {
        search: '',
        status: '',
      },
      statusSelected: undefined,
    }
  }

  public onSetSearchValue(field: keyof ICustomerContractServiceSearchDTO, value: string) {
    const { searchValues } = this.state;
    const { onSearch } = this.props;
    searchValues[field] = value;
    this.setState({ searchValues });
    onSearch(searchValues);
  }

  public onSearch() {
    const { onSearch } = this.props;
    onSearch(this.state.searchValues);
  }

  public async onSelectStatus(statusOption?: ICustomerContractServiceStatusOption) {
    const selectedValue = statusOption ? statusOption.original : undefined;
    this.onSetSearchValue('status', selectedValue || undefined);
    this.setState({ statusSelected: statusOption });
    setTimeout(() => this.onSearch(), 200);
  }

  public onResetFields() {
    const { onResetSearch } = this.props;
    this.setState({ searchValues: { search: '', status: undefined }, statusSelected: undefined });
    onResetSearch();
  }

  public render() {
    const { classes } = this.props;
    const { searchValues, statusSelected } = this.state;

    const statusOptionsFormatted: ICustomerContractServiceStatusOption[] = _.uniq([
      ...Object.keys(CustomerContractServiceStatusOptions_ONEOFF), 
      ...Object.keys(CustomerContractServiceStatusOptions_RECURRING), 
    ]).map(key => ({
      label: translations.t(`credits.customerContractServiceStatus_${key}`),
      value: key,
      original: key,
    }))

    return (
      <div className={classes.container}>
        <div style={{ marginLeft: 0, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <TextField
            id="outlined-basic"
            label={<ReduxLanguage languageKey={'credits.customerContractServiceSearch'} />}
            variant="outlined"
            type="search"
            style={{ marginRight: 10 }}
            value={searchValues.search}
            onChange={e => this.onSetSearchValue('search', e.target.value)}
          />
          <Select
            isClearable
            key={`my_unique_select_key__${searchValues.status}`}
            value={statusSelected}
            options={statusOptionsFormatted}
            placeholder={<ReduxLanguage languageKey={'recharges.statusSelection'} />}
            onChange={(e) => {this.onSelectStatus(e)}}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, minHeight: 55, minWidth: 200 }),
            }} 
          />
          <Button
            variant="contained"
            style={{ backgroundColor: 'red', color: 'white', marginLeft: 10, fontWeight: 'bold'  }}
            onClick={() => this.onResetFields()}
          >
            <CancelOutlined style={{ color: 'white' }} />
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CustomerContractServicesSearchBar);
